import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_END_POINTS } from '@app/config/api.constants';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RedemptionService {

  private $viewRedemption: BehaviorSubject<any> = new BehaviorSubject(null)
  private $submitTemplate: BehaviorSubject<any> = new BehaviorSubject(null)

  constructor(
    private http: HttpClient
  ) { }

  public set setViewRedUniverse(presetId: any){
    this.$viewRedemption.next(presetId)
  }

  public get viewRedUniverse (): Observable<any> {
    return this.$viewRedemption.asObservable()
  }

  public set submitTemplate(submitTmep: any){
    this.$submitTemplate.next(submitTmep)
  }

  public get getSubmitTemplate (): Observable<any> {
    return this.$submitTemplate.asObservable()
  }

  getRedemptionUniverse(redConfigId?: string): Observable<any> {
    if(redConfigId){
      return this.http.get(`${API_END_POINTS.SETUP.RED.redemption_universe}?redConfigId=${redConfigId}`)
    } else {
      return this.http.get(API_END_POINTS.SETUP.RED.redemption_universe)
    }
  }

  updateRedemptionUniverse(redConfigId: string, data): Observable<any> {
    return this.http.post(`${API_END_POINTS.SETUP.RED.edit_redemption_universe}?redConfigId=${redConfigId}`, data)
  }

  createRedemptionUniverse(data: any): Observable<any> {
    return this.http.post(API_END_POINTS.SETUP.RED.add_redemption_universe, data)
  }
  
  getRedUniverseInstruments(redConfigId: string): Observable<any> {
    return this.http.get(`${API_END_POINTS.SETUP.RED.red_universe}?redConfigId=${redConfigId}`)
  } 

  deleteRedUniverseInstruments(redConfigId: string, pickrightAssetId: string): Observable<any> {
    return this.http.delete(`${API_END_POINTS.SETUP.RED.red_universe}?redConfigId=${redConfigId}&pickrightAssetId=${pickrightAssetId}`)
  } 

  getRedInstrumentsGroupInfo(redConfigId: string): Observable<any> {
    return this.http.get(`${API_END_POINTS.SETUP.RED.groupinfo}?redConfigId=${redConfigId}`)
  }

  uploadExcel(redConfigId: string, file: any): Observable<any> {
    const formData = new FormData()
    formData.append('file', file)
    return this.http.post(`${API_END_POINTS.SETUP.RED.upload_excel}?redConfigId=${redConfigId}`, formData)
  }

  downloadExcel(redConfigId: string){
    return this.http.get(`${API_END_POINTS.SETUP.RED.download_excel}?redConfigId=${redConfigId}`, {responseType: 'arraybuffer'})
  }
}
